import { render, staticRenderFns } from "./Collaborator.vue?vue&type=template&id=8955eb02"
import script from "./Collaborator.vue?vue&type=script&lang=js"
export * from "./Collaborator.vue?vue&type=script&lang=js"
import style0 from "./Collaborator.vue?vue&type=style&index=0&id=8955eb02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports